import Tag from "./TagControl"
export default Tag;
